export function getPathByArray({ data }) {
  if (!data) return { eyesPath: '', eyelidsPath: '', eyeBrowPath: '' };

  const { eyebrow, eyes } = data;

  if (!eyes || eyes.length < 1 || !eyebrow || eyebrow.length < 1) {
    return { eyesPath: '', eyelidsPath: '', eyeBrowPath: '' };
  }

  const eyesPath = `M${eyes[0].x} ${eyes[0].y}
  C${eyes[1].x},${eyes[1].y} ${eyes[2].x},${eyes[2].y} ${eyes[3].x},${eyes[3].y}
  L${eyes[4].x},${eyes[4].y}`;

  const curve = 4;
  const eyelidsPath = `M${eyes[0].x - 0.3} ${eyes[0].y - 5}
  C${eyes[1].x + curve / 2 - 2},${eyes[1].y - curve} ${eyes[2].x - curve + 2},${
    eyes[2].y - curve
  } ${eyes[3].x},${eyes[3].y - curve + 0.5}
`;
  const eyeBrowPath = `M${eyebrow[0].x} ${eyebrow[0].y}
  C${eyebrow[1].x} ${eyebrow[1].y}
  ${eyebrow[2].x} ${eyebrow[2].y}
  ${eyebrow[3].x} ${eyebrow[3].y}`;

  return { eyesPath, eyelidsPath, eyeBrowPath };
}
